<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="contactwidget__background module__background"
        >
        </app-modulebackground>
        <div
            class="contactwidget__container module__container"
            v-bind:class="{
                'container__boxed--half': [1, 2, 3, 4].includes(module.layout.type),
                container__boxed: [5, 6].includes(module.layout.type)
            }"
        >
            <div class="contactwidget__inner module__inner">
                <div class="contactwidget__inner--main module__inner--main">
                    <div
                        class="contactwidget__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="contactwidget__inner-col module__inner-col">
                            <div class="contactwidget__header module__header">
                                <h2
                                    class="contactwidget__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="contactwidget__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="contactwidget__inner-row module__inner-row">
                        <div class="contactwidget__inner-col module__inner-col">
                            <div class="contactwidget__content-block module__content-block">
                                <div
                                    class="contactwidget__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 5, 6].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [3, 4].includes(module.layout.type)
                                    }"
                                    v-if="
                                        module.data.text ||
                                            ([3, 4].includes(module.layout.type) &&
                                                getPageUrlFromType('contact'))
                                    "
                                >
                                    <div
                                        class="contactwidget__inner-row module__inner-row"
                                        v-if="module.data.text"
                                    >
                                        <div class="contactwidget__inner-col module__inner-col">
                                            <div
                                                class="contactwidget__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="contactwidget__inner-row module__inner-row"
                                        v-if="
                                            [3, 4].includes(module.layout.type) &&
                                                getPageUrlFromType('contact')
                                        "
                                    >
                                        <div class="contactwidget__inner-col module__inner-col">
                                            <div class="contactwidget__cta module__cta">
                                                <app-modulebutton
                                                    v-if="[3, 4].includes(module.layout.type)"
                                                    :href="getPageUrlFromType('contact')"
                                                    :custom-class="
                                                        'contactwidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                    >Kontaktieren Sie uns
                                                </app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="contactwidget__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 5, 6].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [3, 4].includes(module.layout.type)
                                    }"
                                >
                                    <div class="contactwidget__details">
                                        <ul class="contactwidget__details-list">
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('firma1')"
                                            >
                                                {{ data('firma1') }}
                                            </li>
                                            <li
                                                class="contactwidget__details-list-item contactwidget__details-list-item--company-addition font-bold border-color"
                                                v-if="misc('firmierung')"
                                            >
                                                {{ misc('firmierung') }}
                                            </li>
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('strasse')"
                                            >
                                                {{ data('strasse') }}
                                            </li>
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('plz') && data('ort')"
                                            >
                                                {{ data('plz') }} {{ data('ort') }}
                                            </li>
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('land')"
                                            >
                                                {{ data('land') }}
                                            </li>
                                        </ul>
                                        <ul class="contactwidget__details-list">
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('telefon')"
                                            >
                                                Telefon:
                                                <a
                                                    :href="'tel:' + data('telefon')"
                                                    class="font-bold module__link--underlined"
                                                    >{{ data('telefon') }}</a
                                                >
                                            </li>
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('fax')"
                                            >
                                                Fax: {{ data('fax') }}
                                            </li>
                                            <li
                                                class="contactwidget__details-list-item font-bold border-color"
                                                v-if="data('email')"
                                            >
                                                E-Mail:
                                                <a
                                                    :href="'mailto:' + data('email')"
                                                    class="font-bold module__link--underlined"
                                                    >{{ data('email') }}</a
                                                >
                                            </li>

                                            <app-emergencyphone
                                                custom-tag="li"
                                                custom-class="contactwidget__details-list-item font-bold border-color"
                                            ></app-emergencyphone>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="contactwidget__inner-row module__inner-row"
                        v-if="
                            [1, 2, 5, 6].includes(module.layout.type) &&
                                getPageUrlFromType('contact')
                        "
                    >
                        <div class="contactwidget__inner-col module__inner-col">
                            <div class=" contactwidget__cta module__cta">
                                <app-modulebutton
                                    v-if="[1, 2, 5, 6].includes(module.layout.type)"
                                    :href="getPageUrlFromType('contact')"
                                    :custom-class="
                                        'contactwidget__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                    >Kontaktieren Sie uns
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import EmergencyPhone from '@/components/assorted/EmergencyPhone';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-emergencyphone': EmergencyPhone,
        'app-modulebackground': ModuleBackground
    },
    methods: {
        data(prop) {
            return this.getProp('deha.user.' + prop);
        },
        misc(prop) {
            return this.getProp('deha.user.misc.' + prop);
        }
    },
    computed: {
        ...mapGetters(['getProp', 'getPageUrlFromType'])
    },
    mounted() {},
    updated() {},
    props: {
        module: Object
    }
};
</script>
